import { useAtom } from 'jotai';
import PropTypes from 'prop-types';
import { activeAtom } from '@/atoms';

export function MenuButton({
  title,
  color = 'text-neutral-neutral-70',
  setIsMenuOpen,
}) {
  const [active, setActive] = useAtom(activeAtom);

  return (
    <button
      className="flex items-center justify-center px-1 py-1 transition-all hover:opacity-80"
      onClick={() => {
        setActive(title);
        setIsMenuOpen?.(false);
      }}
      aria-label={title}
    >
      <div
        className={`${color} text-left font-subtitle-subtitle-3-font-family text-subtitle-subtitle-3-font-size font-subtitle-subtitle-3-font-weight uppercase leading-subtitle-subtitle-3-line-height ${active === title ? 'underline decoration-dotted underline-offset-4' : ''}`}
      >
        {title}
      </div>
    </button>
  );
}

MenuButton.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
  setIsMenuOpen: PropTypes.func,
};
